// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from 'D:/workspace/shilao-lease-super/node_modules/.pnpm/@umijs+plugins@4.6.24_@babe_d722b103bc8e3eb63a9b72833fb70c05/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
